import React from "react"
import useWindowDimensions from "../../hooks/useWindowDimensions"
import { mdWidth } from "../../static/sizes/widths"
import {
  backgroundDesktopLongest,
  backgroundDesktopSecond,
  backgroundDesktopVeryLong,
  backgroundMobileSecond,
  backgroundPhoneVeryLong,
} from "../../static/svgs/background"

type Props = {
  children: React.ReactNode
  isShown?: boolean
  isLong?: boolean
}

const Background = ({ children, isShown = true, isLong = false }: Props) => {
  const { width } = useWindowDimensions()

  if (!isShown) return <>{children}</>

  if (width && width < mdWidth) {
    return (
      <div
        className={`bg-scroll`}
        style={{
          backgroundImage: `url(${backgroundPhoneVeryLong}), url(${backgroundMobileSecond})`,
          backgroundSize: "100% auto",
          backgroundRepeat: "no-repeat, repeat",
          backgroundPositionX: "x-end",
        }}
      >
        {children}
      </div>
    )
  }

  const desktopBg = isLong
    ? backgroundDesktopLongest
    : backgroundDesktopVeryLong

  return (
    <div
      className={`bg-scroll`}
      style={{
        backgroundImage: `url(${desktopBg}), url(${backgroundDesktopSecond})`,
        backgroundSize: "100% auto, 100% auto",
        backgroundRepeat: "no-repeat, repeat",
      }}
    >
      {children}
    </div>
  )
}

export default Background
